import { render, staticRenderFns } from "./CoordonneesPorteur.vue?vue&type=template&id=2d69529d&"
import script from "./CoordonneesPorteur.js?vue&type=script&lang=js&"
export * from "./CoordonneesPorteur.js?vue&type=script&lang=js&"
import style0 from "./CoordonneesPorteur.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports